import { grey, common } from '@material-ui/core/colors'
import { createTheme } from '@material-ui/core/styles'

const black = common.black
const white = common.white

const theme = createTheme({
  palette: {
    primary: {
      main: black,
      light: grey[800],
      contrastText: white,
    },
    secondary: {
      main: white,
      light: grey[200],
      contrastText: black,
    },
    background: {
      default: white,
      paper: white,
    },
    text: {
      primary: black,
      secondary: grey[700],
    },
  },
  typography: {
    fontFamily: 'Open Sans',
  },
  overrides: {
    MuiListItem: {
      root: {
        '&$selected, &$selected:hover': {
          backgroundColor: black,
          color: white,
        },
        borderRadius: 4,
        fontSize: '0.85em',
      },
      button: {
        '&:hover': {
          backgroundColor: grey[200],
        },
      },
    },
    MuiTooltip: {
      arrow: {
        color: black,
      },
      tooltip: {
        backgroundColor: black,
        color: white,
      },
    },
    MuiButton: {
      sizeSmall: {
        fontSize: '0.85em',
      },
    },
    MuiTableCell: {
      head: {
        fontWeight: 600,
        color: black,
        letterSpacing: 0.5,
        lineHeight: '2em',
      },
    },
    MuiFormControlLabel: {
      label: {
        fontSize: '0.9em',
        marginLeft: 8,
      },
    },
    MuiList: {
      padding: {
        padding: 2,
      },
      dense: {
        padding: 2,
      },
    },
    MuiListItemText: {
      primary: {
        fontSize: '0.8rem',
        letterSpacing: 1,
      },
    },
    MuiAccordionSummary: {
      content: {
        '&$expanded': {
          margin: '15px 0px',
        },
      },
      root: {
        '&$expanded': {
          minHeight: 'auto',
        },
      },
    },
    MuiFilledInput: {
      root: {
        backgroundColor: grey[100],
        '&:hover': {
          backgroundColor: grey[300],
        },
        '&$focused': {
          backgroundColor: white,
        },
      },
    },

    MuiTab: {
      root: {
        '&$selected': {
          backgroundColor: white,
          color: black,
        },
      },
    },
    MuiAvatar: {
      colorDefault: {
        backgroundColor: black,
        color: white,
      },
    },
    MuiCheckbox: {
      root: {
        '&$checked': {
          color: `${black} !important`,
        },
      },
      colorPrimary: {
        '&$checked': {
          color: `${black} !important`,
        },
      },
      colorSecondary: {
        '&$checked': {
          color: `${black} !important`,
        },
      },
    },
  },
})

export default theme
